/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react';

import colorMap, { IColor } from '../../helpers/colorMap';

export interface IColorSelect {
  onChange?(colors: IColor[]): void;
}

const ColorSelect = ({ onChange }: IColorSelect) => {
  const [colors, setColors] = useState<IColor[]>([]);

  useEffect(() => {
    if (onChange) onChange(colors);
  }, [colors, onChange]);

  return (
    <ul className="text-lg h-full overflow-y-auto overflow-x-hidden -mx-5">
      <li
        className="flex text-center font-bold py-5 px-5 border-b border-neutral-200 border-opacity-70 items-center"
        onClick={() => {
          setColors([
            {
              name: 'هر رنگی باشد مهم نیست',
              en_name: 'nocolor',
              hex: '#000',
            },
          ]);
        }}
      >
        <span className="w-8 h-8 ml-6 rounded-full overflow-hidden">
          <img
            src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIACIAIgMBIgACEQEDEQH/xAAaAAADAQADAAAAAAAAAAAAAAAABQYEAQID/8QAIxAAAgEDBAIDAQAAAAAAAAAAAAEDAgQhERIxQSIyUWFxBf/EABgBAQEBAQEAAAAAAAAAAAAAAAYHCAUB/8QAIREAAQMEAgMBAAAAAAAAAAAAAAEDBAIFERIxMhQhMwb/2gAMAwEAAhEDEQA/AKqykwhmnrSIrGTgdQ1bqSXP061CSc1mlUM19HvjqX0T8yxoyomp3Usn72PZK108jCwSfSISe/R1bd3FToyBodGQHPkHF3NNlJwPbSTVEvZ18D6yk4JNcWda1NBy2xo1qhV/Ti8dy6GtOaTPeR7o2jy0yFbdwTz9BE3oUntoHo8Nr4OB0kkm+RdZ9D2y6OQCV17GkZY4h9UdZ/VgBxon2QE3rooirXnV+sAAaJwSqrlT/9k="
            className="block w-full h-full"
            alt="rainbow"
          />
        </span>
        هر رنگی باشد مهم نیست
      </li>
      {colorMap().map((color) => (
        <li
          className="flex py-5 px-5 border-b border-neutral-200 border-opacity-70 items-center"
          key={color.en_name}
          onClick={() => {
            if (!!colors.find((clr) => color.en_name === clr.en_name)) {
              setColors([...colors].filter((clr) => clr.en_name !== color.en_name && clr.en_name !== 'nocolor'));
            } else {
              setColors([...colors, color].filter((clr) => clr.en_name !== 'nocolor'));
            }
          }}
        >
          <span className="w-8 h-8 ml-6 rounded-full" style={{ backgroundColor: color.hex }} />
          {color.name}

          <input type="checkbox" checked={!!colors.find((clr) => color.en_name === clr.en_name)} className="mr-auto" />
        </li>
      ))}
    </ul>
  );
};

export default ColorSelect;
